export function TicketStatusBadge({ status }) {
  const label = status ? String(status).replaceAll("_", " ") : "—";
  const key = String(status || "")
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
  let styles = "bg-workspace per-file-hint";
  if (key === "open" || key === "new") {
    styles = "bg-(--status-submitted-bg) text-(--status-submitted-fg)";
  } else if (key === "triggered") {
    styles = "bg-accent/12 text-accent";
  } else if (key === "inprogress" || key === "progress") {
    styles = "bg-(--status-published-bg) text-(--status-published-fg)";
  } else if (key === "waiting" || key === "onhold" || key === "hold") {
    styles = "bg-warning/15 text-warning";
  } else if (key === "resolved") {
    styles = "bg-(--status-archived-bg) text-(--status-archived-fg)";
  } else if (key === "closed") {
    styles = "bg-workspace per-file-hint";
  } else if (key === "rejected") {
    styles = "bg-error/10 text-error";
  } else if (key === "duplicate") {
    styles = "bg-workspace per-file-hint";
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold whitespace-nowrap tracking-wide ${styles}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}

export function TicketPriorityBadge({ priority }) {
  const label = priority || "—";
  const key = String(priority || "").toLowerCase();
  let styles = "bg-workspace per-file-hint";
  if (key === "critical") styles = "bg-error/10 text-error";
  else if (key === "high") styles = "bg-warning/15 text-warning";
  else if (key === "medium") styles = "bg-(--status-submitted-bg) text-(--status-submitted-fg)";

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold whitespace-nowrap ${styles}`}
    >
      {label}
    </span>
  );
}
